import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import preferences from './modules/preferences';
import themes from './modules/themes';
import notifications from './modules/notifications';

// v2
import conversationsV2 from './modules/v2/conversations';
import contactsV2 from './modules/v2/contacts';
import groupsV2 from './modules/v2/groups';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    user,
    preferences,
    themes,
    notifications,

    // v2.0
    conversationsV2,
    contactsV2,
    groupsV2
  },
  strict: debug
});

export default store;
